import React from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import FlowSection from '../../../components/root/shared/FlowSection.tsx';
import { CLIENT_STEP2_TEXT } from '../constants.ts';
import { guaranteesClientStep2Styles } from '../styles.ts';
import type { TClientDocumentsSectionProps } from '../types.ts';
import ClientDocumentRow from './ClientDocumentRow.tsx';

const ClientDocumentsSection: React.FC<TClientDocumentsSectionProps> = ({
  documents,
  uploadingDocumentId,
  downloadingDocumentId,
  deletingDocumentId,
  actionMenuAnchorEl,
  actionMenuDocumentId,
  isDisabled = false,
  onAddDocument,
  onActionMenuOpen,
  onActionMenuClose,
  onDownload,
  onDeleteUploadedDocument,
}) => (
  <FlowSection
    step={CLIENT_STEP2_TEXT.documentsStep}
    title={CLIENT_STEP2_TEXT.documentsTitle}
    description=""
    disabled={isDisabled}
  >
    <Box sx={guaranteesClientStep2Styles.documentsUploadStack}>
      <Box sx={guaranteesClientStep2Styles.documentsList}>
        <Box sx={guaranteesClientStep2Styles.documentsHeader}>
          <Typography sx={guaranteesClientStep2Styles.documentsHeaderCell}>
            {CLIENT_STEP2_TEXT.documentColumnLabel}
          </Typography>
          <Typography sx={guaranteesClientStep2Styles.documentsHeaderCell}>
            {CLIENT_STEP2_TEXT.actionsColumnLabel}
          </Typography>
        </Box>

        {documents.map((document, index) => (
          <ClientDocumentRow
            key={document.id}
            document={document}
            isLast={index === documents.length - 1}
            isUploading={uploadingDocumentId === document.id}
            isDownloading={downloadingDocumentId === document.id}
            isDeleting={deletingDocumentId === document.id}
            isMenuOpen={actionMenuDocumentId === document.id}
            isDisabled={isDisabled}
            actionMenuAnchorEl={actionMenuAnchorEl}
            onActionMenuOpen={(event) => onActionMenuOpen(event, document.id)}
            onActionMenuClose={onActionMenuClose}
            onDownload={onDownload}
            onDeleteUploadedDocument={onDeleteUploadedDocument}
          />
        ))}
      </Box>

      <Box sx={guaranteesClientStep2Styles.documentsUploadActions}>
        <Button
          component="label"
          variant="outlined"
          disabled={isDisabled || !!uploadingDocumentId}
          startIcon={uploadingDocumentId ? <CircularProgress size={18} /> : <AddIcon />}
          sx={guaranteesClientStep2Styles.documentsAddButton}
        >
          {CLIENT_STEP2_TEXT.addDocumentButton}
          <input
            hidden
            type="file"
            onChange={(event) => {
              onAddDocument(event.target.files?.[0]);
              event.target.value = '';
            }}
          />
        </Button>
      </Box>
    </Box>
  </FlowSection>
);

export default ClientDocumentsSection;
